__turbopack_context__.v({
  "textWrapper": "jqgYRq_textWrapper",
});
